/**
 * Career Profile Types
 *
 * Shared types for the career profile feature — used by frontend, backend, and ai-service.
 */
// ─── Enums ───────────────────────────────────────────────────────────────────
export var JobSearchStatus;
(function (JobSearchStatus) {
    JobSearchStatus["NOT_LOOKING"] = "NOT_LOOKING";
    JobSearchStatus["OPEN_TO_OPPORTUNITIES"] = "OPEN_TO_OPPORTUNITIES";
    JobSearchStatus["ACTIVELY_LOOKING"] = "ACTIVELY_LOOKING";
})(JobSearchStatus || (JobSearchStatus = {}));
export var JobType;
(function (JobType) {
    JobType["FULL_TIME"] = "FULL_TIME";
    JobType["PART_TIME"] = "PART_TIME";
    JobType["CONTRACT"] = "CONTRACT";
    JobType["INTERNSHIP"] = "INTERNSHIP";
    JobType["FREELANCE"] = "FREELANCE";
})(JobType || (JobType = {}));
export var LanguageProficiency;
(function (LanguageProficiency) {
    LanguageProficiency["NATIVE"] = "NATIVE";
    LanguageProficiency["FLUENT"] = "FLUENT";
    LanguageProficiency["PROFESSIONAL"] = "PROFESSIONAL";
    LanguageProficiency["CONVERSATIONAL"] = "CONVERSATIONAL";
    LanguageProficiency["BASIC"] = "BASIC";
})(LanguageProficiency || (LanguageProficiency = {}));
export var ProfileVisibility;
(function (ProfileVisibility) {
    ProfileVisibility["PUBLIC"] = "PUBLIC";
    ProfileVisibility["CONNECTIONS_ONLY"] = "CONNECTIONS_ONLY";
    ProfileVisibility["PRIVATE"] = "PRIVATE";
})(ProfileVisibility || (ProfileVisibility = {}));
export function isRestrictedProfile(profile) {
    return 'restricted' in profile && profile.restricted === true;
}
// ── Profile handle (/u/<handle>) ─────────────────────────────────────────────
export const PROFILE_HANDLE_MIN = 3;
export const PROFILE_HANDLE_MAX = 30;
/** Words that read like site pages or staff accounts, never available as handles. */
export const RESERVED_PROFILE_HANDLES = [
    'admin',
    'administrator',
    'api',
    'app',
    'help',
    'login',
    'logout',
    'me',
    'profile',
    'register',
    'root',
    'settings',
    'signup',
    'staff',
    'support',
    'system',
    'u',
    'welynk',
];
/** Lowercase and trim; validation happens in {@link profileHandleError}. */
export function normalizeProfileHandle(raw) {
    return raw.trim().toLowerCase();
}
/** Why a (normalized) handle is invalid, or null when it is acceptable. */
export function profileHandleError(handle) {
    if (handle.length < PROFILE_HANDLE_MIN || handle.length > PROFILE_HANDLE_MAX) {
        return `Use ${PROFILE_HANDLE_MIN}-${PROFILE_HANDLE_MAX} characters.`;
    }
    if (!/^[a-z0-9-]+$/.test(handle))
        return 'Use only letters, numbers and hyphens.';
    if (handle.startsWith('-') || handle.endsWith('-') || handle.includes('--')) {
        return 'Hyphens can only go between letters or numbers.';
    }
    // Profile ids are cuids (25 chars starting with "c"); a handle shaped like
    // one could shadow somebody else's /u/<id> link.
    if (/^c[a-z0-9]{24}$/.test(handle))
        return 'That handle is not available.';
    if (RESERVED_PROFILE_HANDLES.includes(handle))
        return 'That handle is not available.';
    return null;
}
